/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line import/no-mutable-exports
let ls = {
    get: (_name: string) => undefined,
    set: (_name: string) => true,
};

try {
    // eslint-disable-next-line global-require
    ls = require('local-storage');
} catch (error) {
    console.warn('localStorage is not available now');
}

export default ls;
